<ng-container *ngIf="appModeService.isApp(); else webView">
  <app-home-app-top *ngIf="config" [config]="config"></app-home-app-top>
</ng-container>

<ng-template #webView>
  <div class="home-page">
    <app-hero-video *ngIf="config" [config]="config" />
    <app-category />
    <app-catalogue *ngIf="config" [config]="config" />
    <app-banner *ngIf="config" [config]="config" />
    <app-client />
    <app-blog />
  </div>
</ng-template>
